import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

export type Theme = 'legacy' | 'primeng';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private doc = inject(DOCUMENT);
  private current: Theme | null = null;

  private currentThemeSubject = new BehaviorSubject<Theme | null>(null);
  currentTheme$ = this.currentThemeSubject.asObservable();

  apply(theme: Theme): void {
    if (this.current === theme) return;
    this.current = theme;
    this.currentThemeSubject.next(theme);

    if (theme === 'legacy') {
      this.setThemeClass('legacy-theme');
      this.removeStyleClass('prime-ng-theme');
    } else {
      this.setThemeClass('prime-ng-theme');
      this.removeStyleClass('legacy-theme');
    }
  }

  private setThemeClass(className: string): void {
    this.doc.documentElement.classList.add(className);
  }

  private removeStyleClass(className: string): void {
    this.doc.documentElement.classList.remove(className);
  }
}
